import { render, staticRenderFns } from "./Lianbao.vue?vue&type=template&id=f1ff542e&scoped=true"
import script from "./Lianbao.vue?vue&type=script&lang=js"
export * from "./Lianbao.vue?vue&type=script&lang=js"
import style0 from "./Lianbao.vue?vue&type=style&index=0&id=f1ff542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff542e",
  null
  
)

export default component.exports